export var ServiceChargeType;
(function (ServiceChargeType) {
    ServiceChargeType["UNASSIGNED"] = "UNASSIGNED";
    ServiceChargeType["RATE_CARD"] = "RATE_CARD";
    ServiceChargeType["COST_PLUS"] = "COST_PLUS";
})(ServiceChargeType || (ServiceChargeType = {}));
export var ChargeType;
(function (ChargeType) {
    ChargeType["RATE_CARD"] = "Rate Card";
    ChargeType["COST_PLUS"] = "Cost Plus";
})(ChargeType || (ChargeType = {}));
/**
 * Maps a service charge type to a charge type.
 * @param status - The service charge type.
 * @returns The corresponding charge type.
 */
export const serviceToChargeType = (status) => {
    switch (status) {
        case ServiceChargeType.RATE_CARD:
            return ChargeType.RATE_CARD;
        case ServiceChargeType.COST_PLUS:
            return ChargeType.COST_PLUS;
        default:
            return undefined;
    }
};
/**
 * Converts a charge type to a service charge type.
 * @param status - The charge type to convert.
 * @returns The corresponding service charge type.
 */
export const chargeTypeToService = (status) => {
    switch (status) {
        case ChargeType.RATE_CARD:
            return ServiceChargeType.RATE_CARD;
        case ChargeType.COST_PLUS:
            return ServiceChargeType.COST_PLUS;
        default:
            return ServiceChargeType.UNASSIGNED;
    }
};
/**
 * Converts the service specific supply costs to madhive supply costs.
 * @param costValues - The service specific supply costs.
 * @returns The Madhive supply costs.
 */
export const serviceToMadhiveSupplyCosts = (costValues = {}) => {
    const { madhive_supply_creatives, madhive_supply_cost, client_supply_cost, o_and_o_fee, charge_type } = costValues;
    return {
        ...("madhive_supply_creatives" in costValues && {
            madhiveSupplyCreatives: madhive_supply_creatives
        }),
        ...("madhive_supply_cost" in costValues && {
            madhiveSupplyCost: madhive_supply_cost
        }),
        ...("client_supply_cost" in costValues && {
            clientSupplyCost: client_supply_cost
        }),
        ...("o_and_o_fee" in costValues && {
            oAndOFee: o_and_o_fee
        }),
        ...("charge_type" in costValues && {
            chargeType: serviceToChargeType(charge_type)
        })
    };
};
/**
 * Converts Madhive supply costs to service supply costs.
 * @param costValues - The Madhive supply costs to convert.
 * @returns The converted ServiceMadhiveSupplyCosts object.
 */
export const madhiveSupplyCostsToService = (costValues = {}) => {
    const { madhiveSupplyCreatives, madhiveSupplyCost, clientSupplyCost, oAndOFee, chargeType } = costValues;
    return {
        ...("madhiveSupplyCreatives" in costValues && {
            madhive_supply_creatives: madhiveSupplyCreatives
        }),
        ...("madhiveSupplyCost" in costValues && {
            madhive_supply_cost: madhiveSupplyCost
        }),
        ...("clientSupplyCost" in costValues && {
            client_supply_cost: clientSupplyCost
        }),
        ...("oAndOFee" in costValues && {
            o_and_o_fee: oAndOFee
        }),
        charge_type: chargeTypeToService(chargeType)
    };
};
//# sourceMappingURL=supplyCosts.js.map